<template>
  <Dialog
    :visible="showDialog"
    header="Task type"
    modal
    @update:visible="hideHandler">
    <div class="flex justify-content-center form-editor">
      <div class="card">
        <form @submit.prevent="handleSubmit()" class="p-fluid">
          <div class="field">
            <div class="p-float-label">
              <InputText
                id="name"
                v-model="item.name"/>
              <label for="name">Name*</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <InputText
                id="label"
                v-model="item.label"/>
              <label for="label">Label*</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <Dropdown
                id="group"
                v-model="item.workerGroup"
                :options="groups"
                filter
                option-label="name"
                show-clear/>
              <label for="group">Group</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <Textarea
                id="description"
                v-model="item.description"
                rows="5"/>
              <label for="label">Description</label>
            </div>
          </div>
          <Button type="submit" label="Save" class="mt-2"/>
        </form>
      </div>
    </div>
  </Dialog>
</template>

<script>
import TaskTypesService from "@/services/entity/TaskTypesService";
import GroupsService from "@/services/entity/GroupsService";

export default {
  name: "TaskTypeDialog",
  props: {
    showDialog: Boolean,
    editItem: Object
  },
  data() {
    return {
      groups: null
    }
  },
  created() {
    this.service = new TaskTypesService();
    this.groupService = new GroupsService();
  },
  computed: {
    item() {
      return this.editItem
    }
  },
  watch: {
    showDialog(open) {
      if (open) {
        this.groupService.list().then(data => {
          this.groups = data
        })
      }
    }
  },
  methods: {
    handleSubmit() {
      if (this.item.id == null) {
        this.service.create(this.item).then(result => {
          this.item.id = result.id
          //this.item.saved = true
          //this.item.changed = false
          this.hideHandler()
        })
      } else {
        this.service.update(this.item).then(() => {
          //this.item.saved = true
          //this.item.changed = false
          this.hideHandler()
        })
      }
    },
    hideHandler() {
      this.$emit("update:showDialog", false)
    }
  }
}
</script>
